import PropTypes from 'prop-types';
import React from 'react';

const JobConfigView = ({ jobConfig }) => (
  <div className='config'>
    <label className='control-label'>Job Config</label>
    <textarea
      className='saved-job-config'
      value={JSON.stringify(jobConfig, null, 4)}
      readOnly
    />
  </div>
);

JobConfigView.propTypes = {
  jobConfig: PropTypes.object,
};

export default JobConfigView;
